/* eslint-disable react-hooks/exhaustive-deps */
import { API_URL_PAY } from "../../config";
import { useCallback, useEffect, useState } from "react";
import api from "../../config/api";
import { FaSpinner } from "react-icons/fa";

const JumSIM = ({ id, startDate, endDate, trigger }) => {
  const [sim1, setSim1] = useState(0);
  const [sim2, setSim2] = useState(0);
  const [all, setAll] = useState(0);

  const [loading, setLoading] = useState({
    sim1: false,
    sim2: false,
    all: false,
  });

  useEffect(() => {
    if (trigger > 1) {
      // biar ga langsung fetch pas awal render
      loadDataTotal();
      loadDataTotal2();
      loadDataTotalAll();
    }
  }, [id, startDate, endDate, trigger]);

  const loadDataTotal = useCallback(async () => {
    setLoading((prev) => ({ ...prev, sim1: true }));
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=1&periode=5&outletId=${id}&date_first=${startDate}&date_second=${endDate}`
      );
      setSim1(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prev) => ({ ...prev, sim1: false }));
    }
  }, [id, startDate, endDate, trigger]);

  const loadDataTotal2 = useCallback(async () => {
    setLoading((prev) => ({ ...prev, sim2: true }));
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=2&periode=5&outletId=${id}&date_first=${startDate}&date_second=${endDate}`
      );
      setSim2(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prev) => ({ ...prev, sim2: false }));
    }
  }, [id, startDate, endDate, trigger]);

  const loadDataTotalAll = useCallback(async () => {
    setLoading((prev) => ({ ...prev, all: true }));
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=3&periode=5&outletId=${id}&date_first=${startDate}&date_second=${endDate}`
      );
      setAll(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prev) => ({ ...prev, all: false }));
    }
  }, [id, startDate, endDate]);

  return (
    <>
      <div className="col-span-1 flex-col flex border-r-2 text-center border-black">
        <span className="font-bold text-[10px] md:text-[16px] text-amber-700">
          1 SIM
        </span>
        {loading.sim1 ? (
          <div className="flex justify-center items-center h-full">
            <FaSpinner className="animate-spin text-gray-500 text-xl" />
          </div>
        ) : (
          <span className="font-bold text-[10px] md:text-[20px]">
            {sim1 ? sim1.total : 0}
          </span>
        )}
      </div>

      <div className="col-span-1 flex-col flex border-r-2 text-center border-black">
        <span className="font-bold text-[10px] md:text-[16px] text-amber-700">
          2 SIM
        </span>
        {loading.sim2 ? (
          <div className="flex justify-center items-center h-full">
            <FaSpinner className="animate-spin text-gray-500 text-xl" />
          </div>
        ) : (
          <span className="font-bold text-[10px] md:text-[20px]">
            {sim2 ? sim2.total : 0}
          </span>
        )}
      </div>

      <div className="col-span-1 flex-col flex text-center border-black">
        <span className="font-bold text-[10px] md:text-[16px] text-amber-700">
          ALL
        </span>
        {loading.all ? (
          <div className="flex justify-center items-center h-full">
            <FaSpinner className="animate-spin text-gray-500 text-xl" />
          </div>
        ) : (
          <span className="font-bold text-[10px] md:text-[20px]">
            {all ? all.total : 0}
          </span>
        )}
      </div>
    </>
  );
};

export default JumSIM;
